module.exports = __webpack_public_path__ + "static/media/plusIcon.6db0c732.svg";